import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';


export const uMUsersContentTypesApi = createApi({
  reducerPath: 'uMUsersContentTypesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  endpoints: (builder) => ({
    listContentTypes: builder.query({
      query: (params) => ({
        url: `users/content-types/`,
        params,
      }),
      transformResponse: (res) => res.results,
    }),
  }),
});

export const {
  useListContentTypesQuery,
} = uMUsersContentTypesApi;
